<form id="frmsupplierdescriptifs" autocomplete="off" #ngFrmsupplierdescriptifs="ngForm" name="frmsupplierdescriptifs"
    *ngIf="supplier">
    <div class="card">
        <div class="card-header">
            <a class="control-label" data-toggle="collapse" href="#votreentreprisecard" role="button"
                paflabel="Votre_entreprise">
            </a>
        </div>
        <div class="card-body collapse show" id="votreentreprisecard">
            <div>
                <div class="row">
                    <div class="col-5">
                        <label class="control-label" paflabel="Raison_sociale_du_fournisseur"></label>
                        <input type="text" class="form-control" name="supplierName" [(ngModel)]="supplier.SupplierName" maxlength="80"
                            required [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs"
                            controlName="supplierName"></validation-errors>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <paf-combobox
                            [(ngModel)]="supplier.LegalForm"
                            name="legalform"  
                             headerPafLabel="Forme_juridique"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()"
                            [required]="true"
                            [data]="lstLegalforms">
                        </paf-combobox>
                        <validation-errors [form]="ngFrmsupplierdescriptifs"
                            controlName="legalformId"></validation-errors>
                    </div>
                    <div class="col-3">
                         <paf-combobox *ngIf="address"
                             [(ngModel)]="address.Country"  
                             headerPafLabel="Pays"
                             name="address.CountryId" 
                             [required]="true" 
                             (selectedObjectChange)="reloadlstLegalforms($event)"
                             [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()" 
                            [data]="sharedDatasSvc.countries">
                        </paf-combobox>
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="address.CountryId"></validation-errors>
                    </div>
                    <div class="col-2" *ngIf="showSiret">
                        <label class="control-label" paflabel="Code_SIRET"></label>
                        <input type="text" class="form-control" name="siret" [(ngModel)]="Siret" onlyNumbers
                            [siretUnique]="supplier.Id" siretValidator siretActif [supplierId]="supplier.Id" [required]="siretAccess==2"
                            mask="00000000000000"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()"
                            (blur)="findSiret()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="siret"></validation-errors>
                    </div>
                    <div class="col-2" *ngIf="showIntraTva && supplier.FunctionalId=='tvaintra'">
                        <label class="control-label" paflabel="Num_Intratva"></label>
                        <input type="text" class="form-control" name="tvaIntra" 
                            [intraTvaValidator]="supplier"
                            [intraTvaUnique]="supplier.Id" onBlurValidator [(ngModel)]="supplier.TvaIntra"
                            [required]="tvaIntraAccess==2"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()"
                            (blur)="findIntraTva()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="tvaIntra"></validation-errors>
                    </div>
                    <div class="col-2" *ngIf="showIntraTva && supplier.FunctionalId!='tvaintra'">
                        <label class="control-label" paflabel="Num_Intratva"></label>
                        <input type="text" class="form-control" name="tvaIntra" intraTvaWarning onBlurValidator
                            [(ngModel)]="supplier.TvaIntra" [required]="tvaIntraAccess==2"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()"
                            (blur)="findIntraTva()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="tvaIntra"></validation-errors>
                    </div>
                    <div class="col-2" *ngIf="showRsa">
                        <label class="control-label" paflabel="Num_RSA"></label>
                        <input type="text" class="form-control" name="rsa" [(ngModel)]="supplier.Rsa"
                            [required]="rsaAccess==2" [rsaUnique]="supplier.Id"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()"
                            maxlength="14" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="rsa"></validation-errors>
                    </div>
                    <div class="col-2" *ngIf="showDuns">
                        <label class="control-label" paflabel="Duns_Id"></label>
                        <input type="text" class="form-control" name="duns" [(ngModel)]="supplier.Duns"
                            [required]="dunsAccess==2" [dunsUnique]="supplier.Id"
                            [disabled]="DemandeRefInputDisabled() || votreEntrepriseDisabled || !isEditing()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs" controlName="duns"></validation-errors>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div *ngIf="address">
                            <div class="row" *ngIf="address">
                                <div class="col-2">
                                    <label class="control-label" paflabel="Num_dans_la_rue"></label>
                                    <input type="text" class="form-control" name="AddrNum" [(ngModel)]="address.AddrNum"
                                        [disabled]="votreEntrepriseDisabled || !isEditing()" />
                                </div>
                                <div class="col-10">
                                    <label class="control-label" paflabel="Adresse"></label>
                                    <input type="text" class="form-control" name="addr1" [(ngModel)]="address.Addr1"
                                        required [disabled]="votreEntrepriseDisabled || !isEditing()" />
                                    <validation-errors [form]="ngFrmsupplierdescriptifs"
                                        controlName="addr1"></validation-errors>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="control-label" paflabel="Complement_d_adresse"></label>
                                    <input type="text" class="form-control" name="addr2" [(ngModel)]="address.Addr2"
                                        [disabled]="votreEntrepriseDisabled || !isEditing()" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <label class="control-label" paflabel="Code_postal"></label>
                                    <input type="text" class="form-control" name="codepostal" onlyNumbers maxlength="9"
                                        [(ngModel)]="address.PostalCod" required
                                        [disabled]="votreEntrepriseDisabled || !isEditing()" />
                                    <validation-errors [form]="ngFrmsupplierdescriptifs"
                                        controlName="codepostal"></validation-errors>
                                </div>
                                <div class="col-9">
                                    <label class="control-label" paflabel="Ville"></label>
                                    <input type="text" class="form-control" name="city" [(ngModel)]="address.City"
                                        required [disabled]="votreEntrepriseDisabled || !isEditing()" />
                                    <validation-errors [form]="ngFrmsupplierdescriptifs"
                                        controlName="city"></validation-errors>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-auto mt-4">
                        <button *ngIf="canDuplicateSupplier" class="btn btn-sm btn-warning"
                            (click)="triggerModalDuplicate()" paflabel="Dupliquer"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div *ngIf="isFranceGuyaneReunion">
                            <label class="control-label" paflabel="Activite_Code_NAF_ou_APE"></label>
                            <paf-combobox  
                                [data]="sharedDatasSvc.lstApeCods" 
                                [(ngModel)]="supplier.ApeCod" 
                                [required]="apeCodRequired" 
                                name="apeCod" 
                                [disabled]="votreEntrepriseDisabled || !isEditing()"></paf-combobox>                            
                            <input type="hidden" [(ngModel)]="supplier.ApeCod" [required]="apeCodRequired"
                                name="ApeCod">
                            <validation-errors [form]="ngFrmsupplierdescriptifs"
                                controlName="ApeCod"></validation-errors>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <a class="control-label" data-toggle="collapse" href="#contactscard" role="button" paflabel="Contacts"></a>
        </div>
        <div class="card-body collapse show" id="contactscard">

            <label class="control-label" paflabel="Votre_contact_chez_Endel"></label>
            <div class="card">
                <div class="card-body">
                    <div class="d-flex">
                        <div style="width:140px;">
                            <label class="control-label" paflabel="Date_de_la_demande"></label>
                            <kendo-datepicker name="InternalDemandDate" [(ngModel)]="supplier.InternalDemandDate"
                                [disabled]="true" style="width:120px;"></kendo-datepicker>
                        </div>
                        <div class="flex-grow">
                            <contact-row [(contact)]="demandeur" [disabled]="contactENDELDisabled || !isEditing()"
                                [showErrors]="showErrors" [onlyIntUsers]="true"></contact-row>
                        </div>
                    </div>
                </div>
            </div>
            <label class="control-label" paflabel="Vous_Referent_fournisseur"></label>
            <div class="card">
                <div class="card-body">
                    <supp-contact-row 
                        *ngIf="supplierContactRef" 
                        [supplierContact]="supplierContactRef" 
                        [supplierStatut]="supplierStatut"
                        [disabled]="contactReferentDisabled ||!isEditing()" 
                        [updateButton]="true"
                        [showErrors]="showErrors" 
                        (updateSupplierContact)="updateContact($event)">
                    </supp-contact-row>
                    <supp-contact-row 
                        *ngIf="emptySupplierContactRef" 
                        [supplierContact]="emptySupplierContactRef" 
                        [supplierStatut]="supplierStatut"
                        [addButton]="true" 
                        [isEmptyReferent]="true"
                        [isEditing]="isEditing()"
                        (addSupplierContact)="addContactReferent($event)"
                        [disabled]="contactReferentDisabled ||!isEditing()" 
                        [updateButton]="false" 
                        [showErrors]="showErrors" 
                        (updateSupplierContact)="updateContact($event)">
                    </supp-contact-row>
                    
                </div>
            </div>
            <label class="control-label mr-1" paflabel="Contacts"></label>:<label class="control-label ml-1"
                paflabel="Autres_personnes_a_contacter"></label>
            <div class="card">
                <div class="card-body">
                    <div class="d-flex flex-wrap mb-1 align-items-center">
                        <div class="mx-1" style="width:150px;">
                            <label class="control-label" paflabel="Civilite"></label>
                        </div>
                        <div class="mx-1" style="width:200px;">
                            <label class="control-label" paflabel="Prenom"></label>
                        </div>
                        <div class="mx-1" style="width:200px">
                            <label class="control-label" paflabel="Nom" required></label>
                        </div>
                        <div class="mx-1" style="width:200px">
                            <label class="control-label" paflabel="Fonction"></label>
                        </div>
                        <div class="mx-1" style="width:100px">
                            <label class="control-label" paflabel="Telephone"></label>
                        </div>
                        <div class="mx-1" style="width:100px">
                            <label class="control-label" paflabel="Mobile"></label>
                        </div>
                        <div class="mx-1" style="width:180px">
                            <label class="control-label" paflabel="Email"></label>
                        </div>
                        <div class="mx-1" style="width:100px">
                            <label class="control-label" paflabel="Acces_portail"></label>
                        </div>
                    </div>
                    <supp-contact-row *ngIf="isEditing()"
                        name="emptysupplierContact"
                        [supplierContact]="emptysupplierContact" 
                        [noHeader]=true 
                        [addButton]="true"
                        [showErrors]="showErrors" [disabled]="contactAutrestDisabled || !isEditing()"
                        (addSupplierContact)="addContact($event)"
                        [supplierStatut]="supplierStatut">

                        
                        <!-- (ContactRowValidChange)="ContactRowValidChange($event)"  -->
                    </supp-contact-row>
                    <div *ngFor="let sc of supplier.SupplierContacts; let isLast = last">
                        <div *ngIf="sc.IsReferent!=1">
                            <supp-contact-row 
                                name="emptysupplierContact"
                                [supplierContact]="sc" [noHeader]=true [delButton]="true"
                                [showErrors]="showErrors" 
                                [disabled]="contactAutrestDisabled || !isEditing()"
                                [updateButton]="true" 
                                [addButton]="false" 
                                (deleteSupplierContact)="delContact($event)"
                                (updateSupplierContact)="updateContact($event)"
                                (setSupplierContactAsReferent)="setSupplierContactAsReferent($event)"
                                [supplierStatut]="supplierStatut">
                            </supp-contact-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="card">
        <div class="card-header">
            <a class="control-label" data-toggle="collapse" href="#etablissementscard" role="button"
                paflabel="Mieux_vous_connaitre"></a>
        </div>
        <div class="card-body collapse show" id="etablissementscard">
            <div class="row">
                <div class="col-3 mt-3">
                    <switchery-ios [(ngModel)]="topGroup" size="small" name="TopWorkAtClient"
                        [label]="Label('Faites_vous_partie_d_un_groupe') | async"
                        [disabled]="mieuxVousConnaitretDisabled ||!isEditing()">
                    </switchery-ios>
                </div>
                <div class="col-3">
                    <div *ngIf="topGroup">
                        <label class="control-label" paflabel="Nom_du_groupe"></label>
                        <input type="text" class="form-control" name="GroupeName" [(ngModel)]="supplier.GroupName"
                            [required]="topGroup" [disabled]="mieuxVousConnaitretDisabled ||!isEditing()" />
                        <validation-errors [form]="ngFrmsupplierdescriptifs"
                            controlName="GroupeName"></validation-errors>
                    </div>
                </div>
                <div class="col-6">
                    <label class="control-label" paflabel="Site_Web"></label>
                    <input *ngIf="!mieuxVousConnaitretDisabled && isEditing()" type="text" class="form-control"
                        name="siteweb" [(ngModel)]="supplier.WebSite" />
                    <a class="form-control" *ngIf="(mieuxVousConnaitretDisabled ||!isEditing()) && supplier.WebSite"
                        target="blank" [href]="supplierWebSiteUri">{{supplier.WebSite}}</a>
                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <div class="mb-1 mt-4">
                        <switchery-ios [(ngModel)]="isHQ" size="small" id="isHQ" name="isHQ"
                            [label]="Label('S_agit-il_du_siege') | async"
                            [disabled]="mieuxVousConnaitretDisabled ||!isEditing()">
                        </switchery-ios>
                        <switchery-ios [(ngModel)]="withAgencies" size="small" id="withAgencies"
                            name="withAgencies" [label]="Label('Avez-vous_des_agences') | async"
                            [disabled]="mieuxVousConnaitretDisabled ||!isEditing()">
                        </switchery-ios>
                    </div>
                </div>
                <div class="col-2">
                    <div *ngIf="!isHQ">
                        <div *ngIf="isFranceGuyaneReunion">
                            <label class="control-label" paflabel="Num_SIRET_Siege"></label>
                            <input type="text" class="form-control" name="HQSiret" [(ngModel)]="supplier.HQSiret" [supplierId]="supplier.Id"
                                mask="00000000000000" onlyNumbers siretValidator siretActif [SiretHq]="supplier"
                                onBlurValidator [disabled]="mieuxVousConnaitretDisabled ||!isEditing()">
                            <validation-errors [form]="ngFrmsupplierdescriptifs"
                                controlName="HQSiret"></validation-errors>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div *ngIf="withAgencies && (!mieuxVousConnaitretDisabled  && isEditing())" class="mt-4">
                        <button *ngIf="isFranceGuyaneReunion" type="button" class="btn btn-sm btn-primary mr-1"
                            (click)="triggerModal(modalData)">
                            <paflabel lblCod="Afficher_la_liste_des_agences_disponibles"></paflabel>
                        </button>
                        <button type="button" class="btn btn-sm btn-success mr-1" paflabel="Ajouter_une_agence"
                            *ngIf="!newAgencyVisible" (click)="toggleNewAgencyVisible()"></button>
                        <button type="button" class="btn btn-sm btn-warning" paflabel="Annuler_l_ajout_d_agence"
                            *ngIf="newAgencyVisible" (click)="toggleNewAgencyVisible()"></button>
                    </div>
                </div>
            </div>
            <div [hidden]="!withAgencies">
                <agency-row [hidden]="!newAgencyVisible" [agency]="newAgency" [canDelete]=false [canAdd]=true
                    (add)="addAgency($event)"></agency-row>
                <div *ngFor="let agency of selectedAgencies;">
                    <agency-row [agency]="agency" [canDelete]=true (delete)="deleteAgency($event)"
                        [readonly]="mieuxVousConnaitretDisabled ||!isEditing()"></agency-row>
                </div>
            </div>
        </div>
    </div>



    <ng-template #modalData let-modal>
        <div class="modal-header d-flex align-items-center">
            <h5 class="modal-title flex-fill text-center" id="modal-basic-title" paflabel="Liste_des_agences_disponibles"></h5>
            <button id="btnSearchAgencies" class="btn btn-primary btn-sm mr-2" type="button"
                (click)="searchAgencies(null)">
                <paflabel class="mr-1" lblCod="Recharger_les_agences"></paflabel><i class="fa fa-redo"></i>
            </button>
            <button type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="row">
                <div class="col-12">
                    <kendo-grid [data]="gridData" [pageSize]="state.take"
                        [selectable]="{enabled: true, checkboxOnly: true}" [skip]="state.skip" [sort]="state.sort"
                        [filter]="state.filter" [sortable]="{mode:'multiple'}" [pageable]="{pageSizes: [10,20,50,100]}"
                        [filterable]="'menu'" kendoGridSelectBy="siret" [selectedKeys]="selectedSiret" (selectedKeysChange)="onSelectedKeysChange($event)"
                        (dataStateChange)="dataStateChange($event)">
                        <kendo-grid-checkbox-column [showSelectAll]="true" [width]="50">
                        </kendo-grid-checkbox-column>
                        <kendo-grid-column field="siret" title="Siret" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.siret }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column>
                            <ng-template kendoGridHeaderTemplate>
                                <div paflabel="Enseigne"></div>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ getEtabLissementEnseigne(dataItem) }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column>
                            <ng-template kendoGridHeaderTemplate>
                                <div paflabel="Adresse"></div>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ getEtabLissementAdresse(dataItem) }}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
        <div class="modal-footer text-center">
            <button type="button" class="btn btn-warning" (click)="modal.close()" paflabel="Fermer"></button>
            <button type="button" class="btn btn-success" (click)="importerSelection()" paflabel="Importer"
                [disabled]="selectedSiret.length==0"></button>
        </div>
    </ng-template>

</form>